<script type="text/javascript">
  // Flat Fee Group site review
  export default {
    props: ['website'],
    data() {
      return {
        title: 'Flat Fee Group',
        url: 'https://flatfeegroup.com/Arizona',
        updated: '9/18/2023',

        pages: [
          // ========== START OF PAGE ==========
          {
            title: 'HOME',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® |`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `Arizona Flat Fee MLS Listing`,
              `Arizona`,
              `Flat Fee MLS Listing`,
            ],
            h2: [
              `National and Local REALTOR® MLS`,
              `(888) 870-0410`,
              `National and Local REALTOR® MLS`,
              `(888) 870-0410`,
              `Flat Fee Group®`,
              `Our Sign`,
              `5-Star Agent`,
              `BBB Rating`,
              `Arizona REALTOR®`,
              `Flat Fee MLS Listing`,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'ORDER NOW',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/listnow.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - List Now`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `List Now`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'LISTING PLANS',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/listingplans.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Listing Plans`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `Flat Fee MLS Listing Plans`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'BUYERS',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Buyer Rebate Questions',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/buyerrebatequestions.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Buyer Rebate Questions`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `Buyer Rebate Questions`,
                ],
                h2: [
                  ``,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'SELLERS',
            main: 1,
            children: [
              // ========== START OF PAGE ==========
              {
                title: 'Testimonials',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/testimonials.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Testimonials`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `Testimonials`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Compare Us',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/CompareUs.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Compare Us`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `Compare Us`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'Optional Full Service',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/OptionalFullService.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Optional Full Service`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `Optional Full Service`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'How It Works',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/HowItWorks.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - How It Works`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `How It Works`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: 'The Listing Process',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/ListingProcess.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - The Listing Process`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `The Listing Process`,
                ],
                h2: [
                  ``,
                ]
              },
              // ========== START OF PAGE ==========
              {
                title: '3rd Party Referral Sites',
                main: 1,
                url: `https://flatfeegroup.com/Arizona/ReferralSites.php`,
                positives: [
                  ``,
                ],
                negatives: [
                  ``,
                ],
                meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - 3rd Party Referral Sites`,
                meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
                h1: [
                  `3rd Party Referral Sites`,
                ],
                h2: [
                  ``,
                ]
              },
            ],
          },
          // ========== START OF PAGE ==========
          {
            title: 'ABOUT US',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/aboutus.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - About Us`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `About Us`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'FAQS',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/faqs.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Frequently Asked Questions`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `Frequently Asked Questions`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'CONTACT US',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/contact.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Contact Us`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `Contact Us`,
            ],
            h2: [
              ``,
            ]
          },
          // ========== START OF PAGE ==========
          {
            title: 'CLIENT LOGIN',
            main: 1,
            url: `https://flatfeegroup.com/Arizona/login.php`,
            positives: [
              ``,
            ],
            negatives: [
              ``,
            ],
            meta_title: `Arizona Flat Fee MLS Listing | 50+ Photos | By Owner | REALTOR® | - Login into your account`,
            meta_desc: `Flat Fee MLS Listing Arizona. List your property on the local REALTOR® MLS and be a for sale by owner at the same time. Flat Fee Group is national site of local brokers and rated best brokers by Flat Fee Reviews.`,
            h1: [
              `Login into your account`,
            ],
            h2: [
              ``,
            ]
          },

        ],

      }
    },
    computed: {
      compPages: function() {
        var output = [];
        for(var i in this.pages) {
          var temp = JSON.parse(JSON.stringify(this.pages[i]));
          if(temp['children']) { delete temp['children']; }
          output.push(temp);
          if(this.pages[i]['children']) {
            for(var j in this.pages[i]['children']) {
              var temp = JSON.parse(JSON.stringify(this.pages[i]['children'][j]));
              if(temp['children']) { delete temp['children']; }
              output.push(temp);
            }
          }
        }
        return output;
      },
    },
    created() {

    },
    methods: {

    }
  }
</script>

<template>
  <section>

    <w-site-navbar
      :website="website"
      :static="0"
    ></w-site-navbar>
    <main>

      <section class="bg-home pb-5">
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 _z-n1 _bg-repeat-none _bg-size-cover _bg-position-center" style="background-image: url(https://s3.revinre.com/website/Development/background_09.jpg);"></div>
        <div class="position-absolute _pos-l-0 _pos-t-0 _pos-r-0 _pos-b-0 bg-black _o-5"></div>
        <div class="container-fluid pt-15 pb-10 m_py-35">
          <div class="row justify-content-center">
            <div class="col-lg-6">
              <div class="home-content text-center mb-4">
                <h1 class="home-title mb-3 text-white" data-aos="fade-zoom-in">Sell your home and save thousands</h1>
                <p class="text-white home-desc"  data-aos="fade-zoom-in">0% Listing fee | Average savings of $14,250 | 4.7 Star rating on Google</p>
                <div class="row mt-5">
                  <div class="col-sm px-sm-1"><a href="/selling" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-revinre aos-init">I'm selling</a></div>
                    <div class="col-sm px-sm-1"><a href="/buying" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">I'm buying</a></div>
                    <div class="col-sm px-sm-1"><a href="/valuation" data-aos="fade-zoom-in" class="btn btn-lg btn-block mb-2 mb-sm-0 px-1 btn-white">Home valuation</a></div>
                  </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} navigation</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s navigation menu, sub menu's and additional pages.</p>
          </div>

          <div class="border font-weight-bold rounded bg-lighten-success small p-5">
            <h4 class="_underline">Site info</h4>
            <div class="mb-5">
              <div class=""><strong>Company :</strong> {{title}}</div>
              <div class=""><strong>URL :</strong> {{url}}</div>
              <div class=""><strong>Last updated :</strong> {{updated}}</div>

            </div>
            <h4 class="_underline">Main navigation</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="item['main']">
                <div class="font-weight-bolder">{{item['title']}}</div>
                <ul class="pl-5 m-0">
                  <li v-for="(sub1, sub1_i) in item['children']" :key="sub1_i">
                    {{sub1['title']}}
                    <ul class="pl-5 m-0">
                      <li v-for="(sub2, sub2_i) in sub1['children']" :key="sub2_i">
                        {{sub2['title']}}
                      </li>
                    </ul>
                  </li>
                </ul>
              </li>

            </ul>
            <h4 class="mt-5 _underline">Additional pages</h4>
            <ul class="pl-3 m-0">
              <li v-for="(item, item_i) in pages" :key="item_i" v-if="!item['main']">{{item['title']}}</li>
            </ul>
          </div>



        </div>
      </section>

      <section class="section">
        <div class="container-fluid py-5">

          <div class="text-center _w-m-900 mx-auto mb-5">
            <Icon icon="ri:pantone-line" height="45" class="mb-2 text-revinre"></Icon>
            <h2 class="mb-3 text-" data-aos="fade-zoom-in">{{title}} page content</h2>
            <p class="text-" data-aos="fade-zoom-in">Overview of {{title}}'s website content and SEO basics. Scroll through the table vertically and horizontally with the mouse wheel.</p>
          </div>

          <div class="table-responsive">
            <table class="table table-small table-bordered-right table-hover mb-0 text-nowrap border border-light">
              <thead class="bg-lighten-success">
                <tr>
                  <th class="font-weight-bold">Menu item</th>
                  <th class="font-weight-bold">URL</th>
                  <th class="font-weight-bold">Positives</th>
                  <th class="font-weight-bold">Negatives</th>
                  <th class="font-weight-bold">Meta title</th>
                  <th class="font-weight-bold">Meta description</th>
                  <th class="font-weight-bold">H1's</th>
                  <th class="font-weight-bold">H2's</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item, item_i) in compPages" :key="item_i">
                  <td class="bg-light font-weight-bold">{{item['title']}}</td>
                  <td>{{item['url']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['positives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td class="_w-n-400 _w-m-400 text-wrap">
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['negatives']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>{{item['meta_title']}}</td>
                  <td class="_w-n-400 _w-m-400 text-wrap">{{item['meta_desc']}}</td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h1']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                  <td>
                    <ul class="pl-3 m-0">
                      <li v-for="(sub, sub_i) in item['h2']" :key="sub_i">{{sub}}</li>
                    </ul>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </section>

    </main>

    <w-site-footer
      :website="website"
    ></w-site-footer>

  </section>
</template>
